import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { FeatureToggleService } from './feature-toggle.service';

// import { UserService } from './user.service';

@Injectable()
export class GuardSuperUserService implements CanActivate {

	constructor(
		private ftService: FeatureToggleService
		// private userService: UserService
	) { }

	canActivate() {
		return this.ftService.checkAvailable('LBAdmin');
		// return this.userService.getUserInfo().isSuperAdmin;
	}
}



// WEBPACK FOOTER //
// ./src/app/common-services/guard-super-user.service.ts